import { createContext, useContext } from 'react'
import { type ListLayoutStore } from '../store/ListLayoutStore'

export const ListLayoutContext = createContext<ListLayoutStore | null>(null)

export const useListLayoutContext = () => {
  const context = useContext(ListLayoutContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ListLayoutContext')

  return context
}
